<template lang="pug">
  .products
    ProductsInventory(:company="company" :pid="pid")
</template>

<script>
import ProductsInventory from '@/views/admin/ProductsInventory.vue'
export default {
  name: 'ProductsInventoryDetails',
  components: { ProductsInventory },
  props: ['company', 'pid']
}
</script>